import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import Styles from './TimeBetweenTransCard.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import { ChartComponent, IFSkeleton } from 'Components'
import AnalyticsSelectors from 'Stores/Analytics/Selectors'
import AnalyticsActions from 'Stores/Analytics/Actions'
import RequestState from 'Enums/RequestState'
import { useTranslation } from 'react-i18next'
import { useApexResizeObserver } from 'Utils/Resizeobserver'

const TimeBetweenTransCard = ({
  timeBetweenTrans,
  fetchTimeBetweenTrans,
  fetchTimeBetweenTransRequestState,
  filter,
}) => {
  const { t } = useTranslation()
  const chartWrapperRef = useApexResizeObserver()

  useEffect(() => {
    fetchTimeBetweenTrans(filter)
  }, [])

  useEffect(() => {
    fetchTimeBetweenTrans(filter)
  }, [filter])

  const { series, options } = useMemo(() => {
    const breakdown = timeBetweenTrans?.data?.intervalBreakdown ?? []

    const seriesData = breakdown.map((item) => Number(item.percentage) || 0)

    const labels = breakdown.map((item) => item.count)

    return {
      series: seriesData,

      options: {
        chart: {
          height: 390,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: '30%',
              background: 'transparent',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: true,
                fontSize: '16px',
                fontWeight: 600,
                formatter: function (val, opts) {
                  const total = breakdown.reduce(
                    (sum, i) => sum + (Number(i.count) || 0),
                    0,
                  )
                  const rawValue = Math.round((val / 100) * total)
                  return `${rawValue} user`
                },
              },
              total: {
                show: true,
                label: t('Analytics.Total'),
                formatter: () =>
                  `${breakdown.reduce(
                    (sum, i) => sum + (Number(i.count) || 0),
                    0,
                  )} user`,
              },
            },
            barLabels: {
              enabled: true,
              useSeriesColors: true,
              offsetX: -18,
              fontSize: '12px',
              formatter: function (seriesName, opts) {
                return breakdown[opts.seriesIndex]?.label || ''
              },
            },
          },
        },
        labels,
        colors: [
          Colors.Analytics.PeakHour.Shade1,
          Colors.Analytics.PeakHour.Shade2,
          Colors.Analytics.PeakHour.Shade3,
          Colors.Analytics.PeakHour.Shade4,
          Colors.Analytics.PeakHour.Shade5,
          Colors.Analytics.PeakHour.Shade6,
        ],
        fill: {
          type: 'solid',
          opacity: 1,
        },
        stroke: {
          lineCap: 'round',
          width: 2,
        },
      },
    }
  }, [timeBetweenTrans])
  return (
    <div style={{ backgroundColor: Colors.white }} className={Styles.Card}>
      {fetchTimeBetweenTransRequestState === RequestState.LOADING ? (
        <div className={Styles.ChartSkeleton}>
          <IFSkeleton width="100%" height="100%" variant="rectangular" />
        </div>
      ) : (
        <div className={Styles.Content} ref={chartWrapperRef}>
          <ChartComponent
            type="radialBar"
            options={options}
            series={series}
            height="100%"
            width="100%"
            className={Styles.Chart}
          />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  timeBetweenTrans: AnalyticsSelectors.getTimeBetweenTrans(state),
  fetchTimeBetweenTransRequestState:
    AnalyticsSelectors.getTimeBetweenTransRequestState(state),
})

function mapDispatchToProps(dispatch) {
  return {
    fetchTimeBetweenTrans: (filter) =>
      dispatch(AnalyticsActions.fetchTimeBetweenTrans(filter)),
  }
}

TimeBetweenTransCard.propTypes = {
  fetchTimeBetweenTrans: PropTypes.func,
  fetchTimeBetweenTransRequestState: PropTypes.number,
  timeBetweenTrans: PropTypes.object,
  filter: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TimeBetweenTransCard)
